import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromDomainSettingsEdit from './domain-settings-edit.reducer';
import * as fromDomainSettings from './domain-settings.reducer';

export interface State {
  domainSettings: fromDomainSettings.State;
  domainSettingsEdit: fromDomainSettingsEdit.State;
}

export const reducers = {
  domainSettings: fromDomainSettings.reducer,
  domainSettingsEdit: fromDomainSettingsEdit.reducer,
};

const privateDomainState = createFeatureSelector<State>('PrivateDomain');

export const getDomainSettingsState = createSelector(
  privateDomainState,
  (state) => state.domainSettings,
);

export const getDomainSettings = createSelector(
  getDomainSettingsState,
  fromDomainSettings.getDomainSettings,
);

export const getSearchQuery = createSelector(
  getDomainSettingsState,
  fromDomainSettings.getSearchQuery,
);

export const getDomainSettingsEditState = createSelector(
  privateDomainState,
  (state) => state.domainSettingsEdit,
);

export const getAccounts = createSelector(
  getDomainSettingsEditState,
  fromDomainSettingsEdit.getAccounts,
);

export const getSections = createSelector(
  getDomainSettingsEditState,
  fromDomainSettingsEdit.getSections,
);

export const getSelectedAccountDomainSetting = createSelector(
  getDomainSettingsEditState,
  fromDomainSettingsEdit.getSelectedAccountDomainSetting,
);

export const getSelectedAccountDomainName = createSelector(
  getDomainSettingsEditState,
  fromDomainSettingsEdit.getSelectedAccountDomainName,
);

export const getSelectedAccountId = createSelector(
  getDomainSettingsEditState,
  fromDomainSettingsEdit.getSelectedAccountId,
);

export const getSelectedAccountToggle = createSelector(
  getDomainSettingsEditState,
  fromDomainSettingsEdit.getSelectedAccountToggle,
);

export const getSelectedSectionsDomains = createSelector(
  getDomainSettingsEditState,
  fromDomainSettingsEdit.getSelectedSectionsDomains,
);
